export enum ErrorMessageType {
	MISSING_VALUE = 'value_error.missing'
}
